import { Expose, Transform } from 'class-transformer';
import { snakeCaseToPascalCase } from '@/utils/helpers';
import { COMPONENT_TYPES } from '@/models/enums/component-types.enum';

import { SurveyElementValue } from './element-value';
export class SurveyElement {
  @Expose()
  id!: number;

  @Expose()
  order!: number;

  @Expose({ name: 'is_required' })
  isRequired!: boolean;

  @Expose({ name: 'external_api_identifier' })
  externalApiIdentifier!: string;

  @Expose({ name: 'is_answerable' })
  isAnswerable!: boolean;

  @Expose({ name: 'is_deleted' })
  isDeleted!: boolean;

  @Expose({ name: 'element_type' })
  @Transform(({ value }) => (value ? snakeCaseToPascalCase(value) : undefined))
  elementType!: COMPONENT_TYPES | undefined;

  value?: SurveyElementValue;
}
